export const shipmentKeys = {
  all: ["supplier-processing-shipments"],

  lists: (filters) => [
    "supplier-processing-shipments",
    "list",
    filters,
  ],

  detail: (shipmentCode) => [
    "supplier-processing-shipments",
    "detail",
    shipmentCode,
  ],
};
